<template>
  <div class="container-fluid full-height">
    <div class="row justify-content-center align-items-center full-height">
      <div class="col-10 col-sm-8 col-md-6 col-xl-6">
        <card>
          <h2 slot="header" class="card-title text-center">
            <strong>Login</strong>
          </h2>
          <hr />
          <form @submit.prevent="login">
            <div class="row justify-content-md-center">
              <div class="col-11" style="display: none"></div>
              <div class="col-11">
                <fg-input type="email"
                          v-model="user.email.value"
                          label="E-mail"
                          placeholder="Enter E-mail"
                          data-vv-value-path="user.email.value"
                          v-validate="user.email.rule"
                          data-vv-name="email"
                          cus-name="email"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-11">
                <fg-input type="password"
                          v-model="user.password.value"
                          label="Password"
                          placeholder="Enter Password"
                          data-vv-value-path="user.password.value"
                          v-validate="user.password.rule"
                          data-vv-name="password"
                          cus-name="password"
                          :has-errors="errors"
                          :is-fields="fields">
                </fg-input>
              </div>
              <div class="col-11">
                <button type="submit"
                        :disabled="errors.any() || !isComplete"
                        class="btn btn-primary btn-fill btn-block">
                  Login
                </button>
                <div class="my-2">
                  <router-link to="/forget-password">Forget your password ?</router-link>
                </div>
              </div>
              <div class="col-11 text-center" v-if="isMessage.text">
                  <div class="alert" :class="{'alert-success': !isMessage.error, 'alert-danger': isMessage.error}">
                      <i class="fa"
                         :class="{'fa-check-circle': !isMessage.error, 'fa-exclamation-circle': isMessage.error}"></i>
                      <strong>{{isMessage.text}}</strong>
                  </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue';
  import errors from 'src/helpers/appErrors';

  export default {
    components: {
      Card
    },
    data () {
      return {
        user: {
          email: {
//            value:'abdul.rehman@pk.ewsystemsinc.com',
            value:'',
            rule:{ required: true, email: true}
          },
          password:{
//            value:'Pakistan123@',
            value:'',
            rule:{ required: true}
          }
        },
        message: {
            error: false,
            text: ''
        }
      }
    },
    methods: {
      login () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            // eslint-disable-next-line
              let payload = {
                  email: this.user.email.value,
                  password: this.user.password.value,
              }
              console.log("this.$store.state : ", this.$store.state);
            this.$store.dispatch('AUTH_REQUEST', payload)
            .then((res) => {
                  console.log("login response : ", res);
                  this.message.error = res.error;
                  this.message.text = errors(res.message);
                  !this.message.error && this.redirect();
            })
            .catch(err => {
                console.log("login error : ", err);
            })
          }
        }, (err) =>{
          console.log("err : ", err);
        })
      },
        redirect(){
            setTimeout(() => {
                this.message.error = false;
                this.message.text = '';
                this.$router.push('/');
            }, 1000);
        }
    },
    computed: {
      isMessage(){
        return this.message;
      },
      isComplete () {
        return this.user.email.value && this.user.password;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Auth/Login.vue